import { GlobalConstants } from './../global-constants';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class InterceptorService implements HttpInterceptor {


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${sessionStorage.getItem(GlobalConstants.jwtSessionKey)}`
            }
        });

        return next.handle(request);
    }
}
